// src/util/apprenticeship_api_util.js
import axios from "axios";

export const unlockApprenticeship = (studentId, bookingLink = "") =>
  axios
    .post(`/api/apprenticeships/${studentId}/unlock`, { bookingLink })
    .then((res) => res.data);

export const updateBookingLink = (studentId, bookingLink = "") =>
  axios
    .patch(`/api/apprenticeships/${studentId}/booking-link`, { bookingLink })
    .then((res) => res.data);

export const fetchMyApprenticeship = () =>
  axios.get("/api/apprenticeships/me").then((res) => res.data);

export const createCaseStudy = (type) =>
  axios.post("/api/apprenticeships/me/case-studies", { type }).then((res) => res.data);

// NOTE: submit uses multipart; you'll do it in the component with FormData
export const submitSession = ({ index, session, beforeFiles = [], afterFiles = [] }) => {
  const fd = new FormData();
  beforeFiles.forEach((f) => fd.append("before", f));
  afterFiles.forEach((f) => fd.append("after", f));

  return axios
    .post(`/api/apprenticeships/me/case-studies/${index}/${session}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);
};

export const updateSessionInfo = ({ index, session, clientName, sessionAt }) =>
  axios
    .patch(`/api/apprenticeships/me/case-studies/${index}/${session}/info`, {
      clientName,
      sessionAt,
    })
    .then((res) => res.data);

export const updateSessionInfoForStaff = ({ studentId, index, session, clientName, sessionAt }) =>
  axios
    .patch(`/api/apprenticeships/${studentId}/case-studies/${index}/${session}/info`, {
      clientName,
      sessionAt,
    })
    .then((res) => res.data);


export const fetchApprenticeshipForUser = (studentId) =>
  axios.get(`/api/apprenticeships/${studentId}`).then((res) => res.data);

export const reviewApprenticeshipSession = ({ studentId, index, session, status, reviewerNotes }) =>
  axios
    .patch(`/api/apprenticeships/${studentId}/case-studies/${index}/${session}/review`, {
      status,
      reviewerNotes,
    })
    .then((res) => res.data);

    
export const deleteCaseStudy = (index) =>
  axios.delete(`/api/apprenticeships/me/case-studies/${index}`).then((res) => res.data);


export const fetchPendingSummary = async (studentIds = []) => {
  const ids = (studentIds || []).map(String).filter(Boolean);
  if (!ids.length) return {};

  const res = await axios.get("/api/apprenticeships/staff/pending-summary", {
    params: { studentIds: ids.join(",") },
  });

  return res.data || {};
};

export const staffDeleteCaseStudy = (studentId, index) =>
  axios.delete(`/api/apprenticeships/${studentId}/case-studies/${index}`).then((res) => res.data);

export const removeApprenticeship = async (studentId) => {
  const res = await axios.post(`/api/apprenticeships/${studentId}/remove`);
  return res.data;
};
